export default __webpack_public_path__ + "static/media/deposite.385f43e7.svg";